// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".region-selector[data-v-237b4078]{font-family:\"Knockout 49 A\",\"Knockout 49 B\",sans-serif;font-weight:400;letter-spacing:.166em;text-transform:uppercase;font-size:14px;display:flex;align-items:center;position:relative}.label[data-v-237b4078]{margin-right:20px}.selector[data-v-237b4078]{max-width:90px}", ""]);
// Exports
module.exports = exports;
